<template>
  <div v-if="$fetchState.pending || (!$fetchState.pending && items.length)">
    <template v-if="$fetchState.pending">
      <OSkeleton class="mb-8 lg:mb-13 w-56" height="24px" :rounded="false">
      </OSkeleton>
      <div class="flex justify-between space-x-13">
        <OSkeleton class="flex-1" height="260px" :rounded="false"></OSkeleton>
        <OSkeleton
          class="flex-1 hidden sm:block"
          height="260px"
          :rounded="false"
        ></OSkeleton>
        <OSkeleton
          class="flex-1 hidden md:block"
          height="260px"
          :rounded="false"
        ></OSkeleton>
        <OSkeleton
          class="flex-1 hidden lg:block"
          height="260px"
          :rounded="false"
        ></OSkeleton>
      </div>
    </template>
    <template v-else>
      <h3 class="text-black-light font-bold text-lg lg:text-xl mb-8 lg:mb-13">
        Annunci correlati
      </h3>
      <Swiper
        :options="swiperOptions"
        navigation
        pagination
        dots-position="outside"
      >
        <div v-for="(item, i) in items" :key="i" class="swiper-slide">
          <PropertyCard :equal-height="true" :property="item" />
        </div>
      </Swiper>
    </template>
  </div>
</template>

<script>
import PropertyCard from '~/components/PropertyCard.vue'
import Swiper from '~/components/Swiper.vue'

export default {
  components: {
    PropertyCard,
    Swiper,
  },
  props: {
    property: {
      type: Object,
      required: true,
    },
  },
  fetchOnServer: false,
  data() {
    return {
      items: [],
      swiperOptions: {
        observer: true,
        observeParents: true,
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          480: {
            slidesPerView: 2,
            spaceBetween: 32,
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 32,
          },
        },
      },
    }
  },
  async fetch() {
    try {
      const res = await this.$axios.get(
        `/_api/api/v2/properties/${this.property.id}/related`
      )

      // @FIXME: Remove this when the v2 API of favorites and suggested properties
      // will be completely supported.
      const items = res.data.data.map((it) => ({ ...it.attributes }))

      this.items = items
    } catch (e) {
      this.items = []
    }
  },
}
</script>
